import styled from 'styled-components'
import ScrollContainer from 'react-indiana-drag-scroll'
import { Tabs, TabList, Tab, TabPanel } from 'react-aria-components'

import { mq, pxToRem, sizes } from '../../theme'

export const Container = styled.section`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.m375_h1}
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  border-block-start: 1px solid rgba(0, 0, 0, 0.5);
  padding-block-start: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
    max-width: calc(100% - ${pxToRem(32)} * 2);
    border-block-start: 0;
    padding-block-start: 0;
  }
`
export const _Tabs = styled(Tabs)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(100)};
  }
`
export const Scroller = styled(ScrollContainer)`
  padding-inline: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
  }
`
export const _TabList = styled(TabList)`
  display: flex;
  flex-flow: row nowrap;
  min-width: 100%;
  width: fit-content;
  border-block-end: 1px solid rgba(0, 0, 0, 0.5);
`
export const _Tab = styled(Tab)`
  ${({ theme }) => theme.textStyles.m375_editoBody}
  display: flex;
  align-items: center;
  height: ${pxToRem(56)};
  padding-inline: ${pxToRem(32)};
  border: 1px solid transparent;
  border-block-end: 0 none;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  translate: 0 1px;
  transition:
    border-color 0.2s,
    color 0.2s ease-in-out;
  &[aria-selected='true'] {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: rgba(0, 0, 0, 0.5);
    color: rgba(0, 0, 0, 1);
    outline: 0 none !important;
  }
  &:not([aria-selected='true']) {
    cursor: pointer;
  }
  &:not([aria-selected='true']):hover {
    color: rgba(0, 0, 0, 1);
    text-decoration: underline;
  }
  @media ${mq(sizes.desktop)} {
    height: ${pxToRem(70)};
  }
`
export const _TabPanel = styled(TabPanel)`
  & [role='separator'] {
    display: none;
  }
  & > * {
    padding-block-start: 0;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  @media ${mq(sizes.tablet)} {
  }
`
